import { nanoid } from 'nanoid';
import { isClient } from '../../../utils/is-client';
import { canIUseApi } from '../../../utils/can-i-use-api';

export const useSessionId = () => {
  try {
    if (!isClient()) return;
    if (!canIUseApi('sessionStorage')) return;

    const key = 'support-center-session-id';

    // check to see if we have a session already saved
    const value = sessionStorage.getItem(key);
    if (value) return value;

    // no value found, add a new one to session storage, and return
    const sessionId = nanoid();
    sessionStorage.setItem(key, sessionId);

    return sessionId;
  } catch (error) {
    console.error('unable to use session storage', error);
    return null;
  }
};
